import React from 'react';
import { Row, Col, Typography } from 'antd';
import { TeamOutlined, CarOutlined, SettingOutlined, BellOutlined } from '@ant-design/icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const HOW_IT_WORKS_ITEMS = [
  { key: 'sharedBalance', Icon: TeamOutlined },
  { key: 'parkingPayments', Icon: CarOutlined },
  { key: 'adminManaged', Icon: SettingOutlined },
  { key: 'lowBalanceAlerts', Icon: BellOutlined },
];

const HowWalletWorksGrid = () => {
  const { translateText } = useTranslation();

  return (
    <div className={styles.howItWorks}>
      <Typography.Title level={5} className={styles.howItWorksTitle}>
        {translateText('corporateAccounts.wallet.create.howItWorks.title')}
      </Typography.Title>
      <Row gutter={[40, 20]}>
        {HOW_IT_WORKS_ITEMS.map(({ key, Icon }) => (
          <Col xs={24} md={12} key={key}>
            <div className={styles.howItWorksItem} data-testid={`howItWorks-${key}`}>
              <Icon className={styles.howItWorksIcon} />
              <div>
                <Typography.Text strong className={styles.howItWorksItemTitle}>
                  {translateText(`corporateAccounts.wallet.create.howItWorks.${key}.title`)}
                </Typography.Text>
                <Typography.Paragraph className={styles.howItWorksDescription}>
                  {translateText(`corporateAccounts.wallet.create.howItWorks.${key}.description`)}
                </Typography.Paragraph>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HowWalletWorksGrid;
